import React from 'react';
import {Check} from 'Agent/Claims/models/Check';
import {Grid} from '@material-ui/core';
import CheckPayment from 'Agent/Claims/components/CheckPayment';

type ChecksIssuedSummaryProps = {
  checks: Check[];
  claimNumber: string;
};

const ChecksIssuedSummary = (props: ChecksIssuedSummaryProps) => {
  const {checks, claimNumber} = props;
  return (
    <>
      <Grid container direction="column">
        <span className="checks-list__claim-number-label">Claim {claimNumber}</span>
        <span className="checks-list__checks-issued-label">Checks Issued:</span>
      </Grid>
      <Grid container direction="column" wrap="nowrap">
        {checks.map(check => (
          <CheckPayment check={check} key={`check_${check.issueDate}_${check.paymentType}`} />
        ))}
      </Grid>
    </>
  );
};

export default ChecksIssuedSummary;
